import { IsArray, IsNumber, IsObject, IsOptional, IsString } from 'class-validator';
import { Invoice } from './invoice.interface';
import type { PaymentAddress } from './payment-address.interface';
import type { PaymentMethod } from './payment-method.interface';

export interface AuthenticationData {
  [key: string]: any;
  threeDSRequestData?: {
    nativeThreeDS: 'preferred' | 'disabled';
  };
}

export class CheckoutParamsModel {
  @IsArray()
  invoices: Invoice[];

  @IsNumber()
  amount: number;

  @IsObject()
  paymentMethod: PaymentMethod;

  @IsObject()
  paymentAddress: PaymentAddress;

  @IsOptional()
  @IsString()
  shopperEmail?: string;

  @IsOptional()
  @IsObject()
  browserInfo?: any;

  @IsOptional()
  @IsString()
  channel?: string;

  @IsOptional()
  @IsString()
  origin?: string;

  @IsOptional()
  @IsString()
  returnUrl?: string;

  @IsOptional()
  @IsObject()
  authenticationData?: AuthenticationData;
}
